import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden mx-auto px-4 md:px-6 pt-4">
      <div className="relative w-full h-full rounded-3xl overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20warm%20coral%20red%20and%20deep%20charcoal%20gradients%2C%20flowing%20organic%20shapes%2C%20modern%20editorial%20design%20aesthetic%2C%20soft%20textured%20overlay%2C%20dark%20dramatic%20atmosphere%20with%20warm%20accents%2C%20clean%20minimalist%20composition%2C%20high%20contrast%2C%20magazine%20cover%20style%2C%20bold%20visual%20impact&width=1800&height=1000&seq=hero-bg-home-01&orientation=landscape"
          alt="91爆料网 - 全网独家吃瓜黑料第一站"
          className="absolute inset-0 w-full h-full object-cover"
          title="91爆料网 - 全网独家吃瓜黑料第一站"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>

        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/25 bg-white/10 backdrop-blur-sm mb-6">
            <i className="ri-fire-line text-primary-400 text-sm"></i>
            <span className="text-white/90 text-xs font-medium tracking-wide">今日最新爆料 · 实时更新</span>
          </div>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold font-heading text-white leading-tight max-w-3xl">
            吃瓜群众的<br />核心阵地
          </h1>
          <p className="mt-4 md:mt-6 text-sm md:text-base text-white/70 max-w-xl leading-relaxed">
            全网热门91爆料视频每日实时追踪，为你深度挖掘网红反转黑料与娱乐圈最新大事件
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
            <Link
              to="/category/zuixin-dagua"
              className="whitespace-nowrap px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-semibold rounded-md hover:bg-primary-600 transition-colors cursor-pointer"
            >
              立即吃瓜
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/category/remen-shipin"
              className="whitespace-nowrap px-6 py-3 border border-white/30 text-white text-sm font-medium rounded-md hover:bg-white/10 transition-colors cursor-pointer"
            >
              热门视频
              <i className="ri-play-line ml-2"></i>
            </Link>
          </div>
        </div>

        <div className="absolute bottom-6 left-0 right-0 flex justify-center gap-1.5">
          <div className="w-2 h-2 rounded-full bg-white/60"></div>
          <div className="w-2 h-2 rounded-full bg-white/30"></div>
          <div className="w-2 h-2 rounded-full bg-white/30"></div>
        </div>
      </div>
    </section>
  );
}